// test1956
(1956 && 0);
